import React, { useState } from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { FormHelperText } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import BaseButton from '../../Components/Buttons/BaseButton';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%'
  },
  input: {
    display: 'none'
  },
  label: {
    textTransform: 'none',
    fontSize: 14
  },
  helper: {
    fontSize: 12
  },
  button: {
    height: 58,
    textAlign: 'center',
    width: '100%'
  },
  optionWithErrors: {
    borderColor: '#FE685E',
    borderStyle: 'solid',
    borderWidth: 1,
    '&:hover': {
      borderWidth: 2
    }
  }
}));

const FileInput = (props, ref) => {
  const classes = useStyles();
  const {
    name,
    helperText,
    error,
    accept,
    text,
    id = 'file_input',
    inputProps: fileInputProps = {},
    buttonProps,
    disabled = false,
    multiple = false,
    iconVisible = false,
    Icon = AttachFileIcon,
    containerClass,
    buttonClass
  } = props;

  const [loading, setLoading] = useState(false);

  const handleFileChange = e => {
    setLoading(false);
    if (fileInputProps.onChange) {
      fileInputProps.onChange(e);
    }
  };

  const handleClickInput = e => {
    setLoading(true);
    if (fileInputProps.onClick) {
      fileInputProps.onClick(e);
    }
  };

  const inputProps = {
    onChange: handleFileChange,
    onClick: handleClickInput,
    ...fileInputProps
  };

  return (
    <>
      <div className={clsx(classes.root, containerClass)}>
        <input
          accept={accept}
          className={classes.input}
          id={id}
          type="file"
          name={name}
          ref={ref}
          multiple={multiple}
          disabled={disabled}
          {...inputProps}
        />
        <label htmlFor={id} className={classes.label}>
          <BaseButton
            id={`${id}_button`}
            className={clsx([classes.button, buttonClass], {
              [classes.optionWithErrors]: Boolean(error)
            })}
            variant="outlined"
            color="primary"
            component="span"
            progress
            loading={loading}
            onClick={handleClickInput}
            onBlur={() => setLoading(false)}
            disabled={disabled}
            {...buttonProps}
          >
            {iconVisible && <Icon />}
            {text}
          </BaseButton>
        </label>
        {helperText && (
          <FormHelperText error={Boolean(error)} className={classes.helper}>
            {helperText}
          </FormHelperText>
        )}
      </div>
    </>
  );
};

export default React.forwardRef(FileInput);
